export class AddCartButtonRequest {
  constructor(
    public supplierId: string, 
    public catalogItemCode: string, 
    public quantity: number, 
    public siteType: string
  ) {}
}
